import React, { useState, useEffect } from "react";
import SEO from "../components/SEO";

const committeeData = [
  {
    title: "Chief Patron",
    members: [
      {
        id: 1,
        role: "H'ble Chancellor",
        name: "Mr. P. K. Gupta",
        designation: "H'ble Chancellor, Sharda University, Greater Noida",
        image: "/nclc-2026/assets/chairman.webp",
        about: `A leading educational reformer who has given a new direction to the teaching methodology practiced across the country, Mr. Pradeep Kumar Gupta is the Chairman of Sharda Group of Institutions. Sharda University is set to achieve new heights in the education world with its global outlook and international faculty. Bringing his dream into reality, in 1995, he established the Sharda Education Trust under which he opened up an engineering college in 1996 in Agra, well known as Hindustan Institute of Science & Technology. In 1997, he opened up a second college for students of management and computer science by the name of Hindustan Institute of Management & Computer Studies.

Having been involved in the education industry, he delved deep to understand the lack-lustre output of the industry. This unveiled many facts, like the fact that the examination system only tested the memory rather than testing the intelligence of the students and the fact that teachers only incorporated theoretical knowledge in the classrooms and were exposed to the practical knowledge prevailing outside in the market. Hence, an education system which would inculcate an application based approach in the young students, envigored the thought of opening up educational institutions which would focus more on nurturing the talent and developing curiosity in young individuals, in his mind. Looking at the huge response and demand for colleges, he opened up Anand Engineering College in 1998 and Babu Mohanlal Arya Smarak (BMAS) Engineering College in 1999. He also realized that the custom of not providing higher education to a girl child was still prevailing. As a result of his devotion towards his mother Sharda Gupta, he decided to grant 90% scholarship to girls whose families could not afford to pay their tuition fee. With this step, 70% of admissions were given to girls in 1999. Since then, he made it a point to give out donations and charity only for the education of girls.`,
        link: "https://www.sharda.ac.in/about/leadership/chancellor/",
      },
      {
        id: 2,
        role: "H'ble Pro-Chancellor",
        name: "Mr. Y. K. Gupta",
        designation: "H'ble Pro-Chancellor, Sharda University, Greater Noida",
        image: "/nclc-2026/assets/proc.webp",
        about: `Sharda University looks beyond established boundaries of learning and has made a difference in management and delivery of professional education in India. Behind this was the experience of almost a decade in managing a large conglomerate of education institutions with infrastructure and education delivery processes benchmarked with the best. The university is endowed with a strong foundation of a culture of excellence backed by the best infrastructure and competent faculty with a significant component drawn from institutes of higher learning of national and international standing.

Ever since its establishment in 2009 the University has created facilities for a wide spectrum of disciplines including Engineering, Management, Law, Architecture, Art, Design and Media Studies, Medical and Dental Sciences. In a belief that excellence is defined by the quality of research and innovative approaches, to application of accumulated knowledge to the solution of problems of human existence, the University has put in place necessary appropriate processes for this purpose. The research and Development efforts of the University give due emphasis to inter disciplinary approach while curriculum allows the flexibility of choosing from a wide spectrum of programme.

We, at the University believe that right academic ambience is the main component of excellence in education. Our aim is to create a fully developed autonomous personality capable of functioning effectively in any part of the world and be responsive to civil society. We invite you to share the learning ambience that the University provides to excel in the world of work`,
        link: "https://www.sharda.ac.in/about/leadership/pro-chancellor",
      },
      {
        id: 3,
        role: "Principal Advisor",
        name: "Prof. (Dr.) R.P. Singh",
        designation:
          "Principal Advisor to Honorable Chancellor, Sharda University, Greater Noida",
        image: "/nclc-2026/assets/rp-singh.webp",
        about: `Dr. Ravi P Singh Singh is presently the Provost (Vice Chancellor) at Adani University, Shantigram, Ahmedabad. He spearheads the University which has focus areas on Green Energy, Green Infrastructure, Cyber security and sustainability as its core.

Prior to joining Adani University, Dr Singh was the fourth Secretary General of Quality Council of India (QCI) from 2014-2023. QCI is an independent autonomous body of Department for Promotion of Industry and Internal Trade, Ministry of Commerce & Industry, Government of India. QCI’s mandate is to lead nationwide quality movement in India through its various boards like NABCB, NABL, NABH, NABET, & NBQP.`,
        link: "https://nabcb.qci.org.in/our-leadership/",
      },
    ],
  },

  {
    title: "Patron",
    members: [
      {
        id: 4,
        role: "Vice-Chancellor",
        name: "Prof. (Dr.) Sibaram Khara",
        designation: "Vice-Chancellor, Sharda University, Greater Noida",
        image: "/nclc-2026/assets/Vc_sir.webp",
        about: `Prof. (Dr.) Sibaram Khara is an Electronics & Communication Engineer. He received Ph. D. in engineering from Jadavpur University, Kolkata, in next-generation wireless heterogeneous network–essentially in the area of interworking network and protocol convergence techniques for cellular and WiFi integrated networks. He did PG in Digital Systems from National Institute of Technology, Allahabad. His industry and teaching experience expands in wide areas of communication and networking engineering. He successfully completed the project for the defense services, to enhance the automation of Terminal Equipment of Message Switching network for efficient information management. Currently he is serving as Vice Chancellor in Sharda University. Previously, he has served as Pro Vice Chancellor in Galgotias University.  Before joining Galgotias University he served as Division Chair for Communication Engineering Division and officiating Program Chair in the school of Electronics Engineering at VIT University, Vellore.

He received Best Paper awards for his analytical model of Cellular/WiFi system (IEEE ADCOM 2008 MIT Chennai and IEEE EWT 2004 (1st), I2IT Pune (3rd)). He was honored as best Research Faculty in the School of Electronics Engineering, VIT University, Vellore for year 2010. His research articles are presented at seminars and conferences in many countries, namely, WEAS02 Athens, IEEE VTC06 Melbourne, IEEE PWC07 Prague, IEEE/ACM SAC10 Switzerland, etc. His major research interests cover the areas of cluster based wireless sensor networks, spectrum mobility in cognitive radio system, call admission control in heterogeneous network and carrier aggregation in LTE-A technology.  He visited Goergia Tech, Atlanta, University of Arkansas, University of Massachusetts, Rhode Island University and Brown University, USA. He attended NAFSA 2016 at Denver, USA. He has published number of research papers in reputed International journals and conferences. Professor Khara is well reputed for his innovative teaching pedagogy and techniques which are designed in conformance with Dale Carnegie and Mission 10X concept. He has guided 04 PhD scholars, more than 20 M. Tech and 100 B. tech projects successfully. 

He has supervised 04 PhD scholars and completed one DST funded project of 30 lacs. 

Dr. Khara is the life member of IEI, IETE and member of IEEE. He is editor of International Journal of Research and Reviews in Next Generation Networks (IJRRNGN) (UK) and International Journal of Research and Reviews in Wireless Sensor Networks (IJRRWSN) (UK).  He has been the advisory board member of Science Academy Publisher (2010), UK. He has presented more than 50 guest lecturers in workshops and organized several national and international academic events including conferences, training programs, workshops and panel discussions`,
        link: "https://www.sharda.ac.in/about/leadership/vice-chancellor/",
      },
      {
        id: 5,
        role: "Vice-Chancellor",
        name: "Prof. (Dr.) Parma Nand",
        designation: "Vice-Chancellor, Sharda University, Agra",
        image: "/nclc-2026/assets/parma-nand-sir.webp",
        about: `He is PhD. in Computer Science & Engineering from IIT Roorkee, M.Tech & B.Tech in Computer Science & Engineering from IIT Delhi. Prof Parma Nand is having more than 27 years of experience both in industry and academia. He had received various awards like best teacher award from Union Minister, best students project guide award from Microsoft in 2015 and best faculty award from cognizant in 2016. He had successfully completed government funded projects and spearheaded last five IEEE International conferences on Computing, Communication & Automation (ICCCA), IEEE students chapters, Technovation Hackathon 2019, Technovation Hackathon 2020, International Conference on Computing, Communication, and Intelligent Systems (ICCCIS-2021).
He is member Executive Council of IEEE UP section (R-10), member Executive Committee IEEE Computer and Signal Processing Society, member Exec. India council Computer Society, member Executive Council Computer Society of India, Noida section and has acted as an observer in many IEEE conferences. He is also having active memberships of ACM, IEEE, CSI, ACEEE, ISOC, IAENG, and IASCIT. He is life time member of Soft Computing Research Society (SCRS) and ISTE.

He has delivered many invited/key notes talks at International & National Conferences/ Workshops/Seminars in India & abroad. He has published more than 150 papers in peer reviewed international/national journals and conferences. He has also published number of book chapters in reputed publications like Springer Berlin Heidelberg. He has reviewed no. of books for publications like Tata McGraw-Hill, Galgotias Publications etc. and papers in journals of international repute.  He is an active member of advisory/technical program committee of reputed International/National conferences & reviewer of number of reputed Journals e.g. Springer, Elsevier Journal Computers & Electrical Engineering. His research interest includes Computer Graphics, Algorithm, Distributed Computing and Wireless and Sensor networking. He has successfully completed number of government funded projects. He has spearheaded Ist IEEE International Conference on Computing, Communication & Automation, May 15-16, 2015 (www.iccca2015.com), 2nd IEEE International Conference on Computing, Communication & Automation, April 29-30, 2016 (www.iccca2016.com), 3rd IEEE International Conference on Computing, Communication & Automation, May 5-6, 2017 (www.iccca.in).`,
        link: "https://www.sharda.ac.in/about/leadership/dr-parma-nand-ji/",
      },
      {
        id: 6,
        role: "Dean Research",
        name: "Prof. (Dr.) Bhuvnesh Kumar",
        designation: `Distinguished Professor & Dean Research, Sharda University`,
        image: "/nclc-2026/assets/bhuvneshwar_Ji1.webp",
        about: `Prof. (Dr.) Bhuvnesh Kumar, a Distinguished Professor & Dean Research, Sharda University since Nov 2020, is an aluminous of GB Pant University of Agriculture & Technology, Pantnagar (Nainital), where he obtained his Graduate, Post Graduate & Doctorate degree in Veterinary Medicine. He Joined DRDO as Scientist B (Class -1 Gazetted) under Defence Research & Development Services (DRDS) in Feb 1985

Superannuated from DRDO in Aug 2020 as an Outstanding Scientist and Director, Defence Institute of Physiology & Allied Sciences (DIPAS), New Delhi has earlier served as Director, Defence Institute of High Altitude Research (DIHAR), Leh, and also held Addl Charge of Director, Defence Institute of Bio-energy Research (DIBER), Haldwani (Nainital) and Institute of Nuclear Medicine and Allied Sciences (INMAS), New Delhi for short durations.

He has been a member of Think Tank of DRDO, Project Director of a Flagship Program on "Low Intensity Conflicts", and the Director, Project Monitoring (Life Sciences) at DRDO Head Quarters.

He served DRDO for more than 35 years at various places including strategic locations in Central, Western and Eastern Himalayas to augment fresh food availability for troops deployed in high mountain regions for their health and wellbeing. His focus has been on rapid induction & rapid acclimatization of troops to high altitude and improving high altitude habitability

As Director DIHAR, Leh, he was instrumental in establishing a world highest altitude terrestrial research station at Chang La (Leh), 17,664 ft altitude, which achieved Guinness World Record for DRDO in the year 2016.

Dr Bhuvnesh Kumar has published more than 130 research papers in national & international peer reviewed journals, collated many reports, chaired many scientific sessions and presented research findings in various national & international conferences. He has the credit of filling a dozens of patents and transferring a large number of technologies to industries for commercialization under make in India Mission of the Government of India.

As director DIPAS (DRDO), he established 50 Men Oxygen Enriched Solar Heated Shelter in Extreme Altitudes for rapid induction of soldiers in High and Extreme Altitudes. Also established 50 Men Intermittent Hypoxia Exposure Facility at mountain bases for rapid acclimatization to High Altitude; Climate Simulation Facilities (Human Decompression Chamber for Hypobaric Hypoxia & Cold -50000 ft Altitude with -30 0C ) and Human Climatic Chamber simulating Hot Desert Conditions ( -5 to 60 0C with 10 to 100 % humidity at DIPAS, Delhi.

As a team leader, he has been instrumental in establishing and operationalizing BSL 2 + facility at DIPAS (DRDO) during, the peak of lockdown period (Apr- May 2020) for COVID-19 Testing using RT PCR, and worked as Mission Director for Indo-Israel Joint Project on Covid-19 for Rapid Detection using Newer Technologies. Managed to collect ten thousand Nasopharyngeal, Saliva samples & Voice recording of asymptomatic persons within a week period from various centers in Delhi during Jul-Aug 2020.

He led the team DIPAS (DRDO) to customize UVC technology and developed UV Box & Hand Held UV device for surface disinfection of personal belongings to break the chain of COVID 19 transmission. This customized technology was transferred to dozens of Industries all over the country for its large scale commercialization.

A University Merit Holder, he is a recipient of Commendation Certificate from Dr APJ Abdul Kalam, then Scientific Advisor to Raksha Mantri. Agni Award for excellence in self-reliance, Laboratory Scientist of the Year award are amongst many honours and recognitions to his credit. He has visited many countries for various scientific missions.

His current focus at Sharda University is to promote quality research under New Education Policy of Government of India.`,
        link: "https://www.sharda.ac.in/faculty/details/dr-bhuvnesh-kumar/",
      },
    ],
  },

  {
    title: "Conference Chair",
    members: [
      {
        id: 7,
        role: "Conference Chair",
        name: "Prof. (Dr.) R.C. Singh",
        designation: "Dean Academics, Sharda University, Greater Noida",
        image: "/nclc-2026/assets/RC_sir-1.webp",
        about: `Prof. (Dr.) Ram Chandra Singh is a senior Professor of Physics & Environmental Sciences Department at the Sharda School of Engineering & Science, Sharda University, Greater Noida, India. He holds a Ph.D. in Physics from Banaras Hindu University (1997), where his research focused on the equilibrium properties of molecular liquids and liquid crystals using pair correlation functions and density functional theory. With over 25 years of experience in teaching and research, he has served in various academic and administrative capacities including Dean, Director, Controller of Examinations, and Chief Vigilance Officer. His areas of expertise include molecular liquids, phase transitions, wavelet-based time-series analysis, biometrics, and functional materials for energy applications such as perovskite solar cells and supercapacitors. Prof. Singh has successfully guided five Ph.D. scholars and is currently supervising four more. He has completed three major research projects funded by the Department of Science and Technology (DST), Government of India. His research output includes over 100 publications in reputed SCI/Scopus-indexed journals, more than 15 patents, and several book chapters and edited volumes with publishers such as Springer and CRC Press. His scholarly impact is reflected in a citation count of 1370, an h-index of 18, and an i10-index of 34 (Google Scholar). He has been honored with numerous awards including the Marquis Lifetime Achievement Award (USA), Dronacharya Award, Bharat Vidya Shiromani, and Star of Asia. He is the President of the Society for Research Development and holds editorial positions in various international journals. Prof. Singh has delivered invited lectures at prestigious institutions and conferences in countries such as Italy, Germany, the UK, Canada, Turkey, and Malaysia, and has organized and chaired several national and international scientific conferences.

Dr. Singh has extensively travelled to many countries for delivering talks, research and promoting Indian education abroad. Some notable visits include a short tenure at The Abdus Salam International Centre for Theoretical Physics (ICTP), (Italy); Technical University of Munich (Germany); Fraunhofer Institute (Germany); University of Kaiserslautern (Germany); University of Osnabrueck (Germany); Doppler Institute of Mathematical Physics, Prague (Czech Republic); Instanbul Aydin University (Turkey); University of British Columbia, Vancouver (Canada); Homerton College, Cambridge (UK) and Cambridge University (UK). While on his tours for research and academic discussions, Dr. Singh has also used these opportunities to build collaborative arrangements with Institutions abroad and his University in India. His focus on multi-lateral exchange of ideas and collaboration in research has paid rich dividends in terms of reputed Scientists visiting India and Indian students joining international teams in pioneering areas of basic research.

Dr. Singh has been awarded Research Associateship (1997) by Council of Scientific and Industrial Research (CSIR), New Delhi, and Short-Term Visitor status (2011) in The Abdus Salam International Centre for Theoretical Physics, Italy. He was conferred the "Bharat Vidya Shiromani Award" (2015) by the International Institute of Education and Management, New Delhi, and the "Pride of International Education Excellence Award" (2015) which was presented during Indo-Nepal Friendship Summit in Kathmandu by the Intellectual People and Economic Growth Association, New Delhi. He is also recipient of the "Star of Asia Award" (2015) by International Business Council, New Delhi and the Global Achievers Foundation, New Delhi conferred on him "Bharat Vibhushan Samman Puraskar" (2015) which was presented by Honble Chief Minister of Uttarakhand Shri Harish Rawat at Dehradun. National & International Compendium, New Delhi presented "Lifetime Achievement Award" (2015) to Dr. Singh for his contribution in the field of education and Indian Journalist Compendium, New Delhi conferred on him "Intellectual Quality Excellence Award" (2017) and Shree Narayan Sanskritik Chetna Nyas, Noida (UP) conferred on him "Dronacharya Award" (2018). The Marquis Whos Who, USA has selected Dr. Singh for "Albert Nelson Marquis Lifetime Achievement Award" (2017) and "Lifetime Achievement Award" (2019). Recently, VDGOOD Professional Association, India conferred on him "Lifetime Achievement Award" (2020).

Administrative experience of Dr. Singh has been diverse. He was the Head of the Department of Applied Sciences, Chief Hostel Warden, Chief Proctor, Dean Students Welfare, Dean Academics, Founder Controller of Examinations of Sharda University, Director Academics, Director of Engineering Institutions, Director of Internal Quality Assurance Cell, Dean of School of Basic Sciences and Research and Library Advisor during 1997-2022.`,
        link: "https://www.sharda.ac.in/faculty/details/r-c-singh/",
      },
      {
        id: 8,
        role: "Conference Chair",
        name: "Prof. (Dr.) Pallavi Gupta",
        designation: "Dean, Sharda School of Engineering & Science (SSES)",
        image: "/nclc-2026/assets/Pallavi_Gupta_ECE1.webp",
        about: `Prof. (Dr.) Pallavi Gupta is professor at Electronics and Communication Engineering Department at Sharda University. She received her Ph.D. degrees from Aligarh Muslim University in 2015. She has a rich experience of more than 18 years in teaching and research. Dr Gupta has authored more than twenty five research papers in peer reviewed journal and filed four patents. Her work in automation is recently being appreciated by 'Cold fusion control systems pvt.Ltd. Dr.Gupta is well known for her endeavors in skill development. Her work in the field of Skill development of youths and women empowerment is appreciated by NGO 'Uthan. Also Dr.Gupta is honored recently by NGO 'Muskarahat ek pahal for her work in the field of education to under privileged Children.`,
        link: "https://www.sharda.ac.in/faculty/details/pallavi-gupta-set/",
      },
    ],
  },

  {
    title: "President of ILCS",
    members: [
      {
        id: 9,
        role: "President",
        name: "Prof. (Dr.) Sandeep Kumar",
        designation: "President of ILCS",
        image: "/nclc-2026/assets/Sandeep-kumar.webp",
        about: `Adjunct Professor, Department of Chemistry, Sharda University, Greater Noida, India
Former Professor, Raman Research Institute, Bangalore- 560080, India


• Present President of Indian Liquid Crystal Society (https://ilcs.in)
• ScholarGPS: #29 in the Top 0.05% of all scholars worldwide in liquid crystal field
• Stanford University World-wide Top 2% Scientist List 2021, 2022, 2023, 2024, 2025
• Highest number of publications on Discotic Liquid Crystals in the world
• Google Scholar Citation: 13400; h-index: 53; i-10 Index: 260
• Professor S. Chandrasekhar Memorial Lecture Award 2023
• ILCS Lifetime Achievement Award 2020
• E.T.S. Walton Visiting Professor Award of the Science Foundation of Ireland
• The inaugural LG Philips Display Mid-Career Award presented by the International Liquid Crystal Society`,
        link: "https://scholar.google.com/citations?user=AI_wSdAAAAAJ&hl=en",
      },
    ],
  },

  {
    title: "Convener",
    members: [
      {
        id: 10,
        role: "Convener",
        name: "Dr. Pankaj Kumar Tripathi",
        designation:
          "Assistant Professor Department of Physics & Environmental Sciences (SSES) Sharda University, Greater Noida",
        image: "/nclc-2026/assets/pankaj-sir.webp",
        about: `Dr. Pankaj Kumar Tripathi is an assistant professor in Department of Physics, Sharda University, Greater Noida, India. Previously, He did three years Post-Doctoral Fellow in Department of Physics, Institute of Science, Banaras Hindu University (BHU), Varanasi, India. He was also a postdoc fellow at Konkuk University, Seoul, South Korea in 2022. Dr. Tripathi completed his Ph.D. at Liquid Crystal Research Lab in the Department of Physics, Lucknow University under the supervision of Prof. Rajiv Manohar. During his Ph.D. tenure, He worked as Junior and senior research fellow in an ISRO funded project from 2010 to 2013. His main field of research are polymer liquid crystal and its composites, THz technology, optoelectronics, liquid crystal, and LCDs. In recognition of his achievements, the University Grants Commission (UGC) awarded him very prestigious Dr. D. S. Kothari Post-Doctoral Fellowship in 2014. He was honored to receive the best young research investigator award in 2016, IIT (BHU), Varanasi. He also visited Germany, Sweden, South Korea and Taiwan and delivered lectures in many scientific events. Dr. Tripathi has also been awarded by the Leading Educationist of India in 2018 by the Friendship Forum, New Delhi. He is a life member of the Indian Liquid Crystal Society, International Liquid Crystals Society, British Liquid Crystal Society, and Indian Science Congress, Kolkata. He has also published more than 70 research papers in repute journals describing the properties of liquid crystals and some nanoparticle disperses in LC materials. He has contributed to several important peer-reviewed scientific publications in the field of liquid crystals. Currently, Dr. Tripathi is also an editorial board member of the Materials Physics and Chemistry journal. His current research interests are novel Liquid crystals and their nano-composites for display, Photovoltaic and photonic applications, Discotic liquid crystal materials for energy applications, Thermoelectric and ferroelectric materials, 2D nanomaterials, quantum dots, etc.`,
        link: "https://scholar.google.com/citations?user=pC1-oJ0AAAAJ&hl=en`",
      },
    ],
  },

  {
    title: "Co-Convener",
    members: [
      {
        id: 11,
        role: "Co-Convener",
        name: "Prof. (Dr.) Mohit Sahni",
        designation:
          "Associate Dean Research, Sharda University, Greater Noida",
        image: "/nclc-2026/assets/Mohit_Sahni-1.webp",
        about:
          "Dr. Mohit Sahni has done MSc (Physics) from IIT Roorkee and PhD from PhD from MNNIT Allahabad. Dr. Sahni is professor in department of Physics. He has published more than 50 papers in highly reputed journal and his expertise is in synthesis of multiferroic nanoparticles and growth of thin films. In addition to academic and research activities, he also worked as Chief Warden, Associate Dean student welfare. Currently he is working as Associate Dean Research and PhD cell Head at Sharda University",
        link: "https://www.sharda.ac.in/faculty/details/mohit-sahni/",
      },
    ],
  },

  {
    title: "Organizing Secretary",
    members: [
      {
        id: 13,
        role: "Organizing Secretary",
        name: "Anjani Kumar Tiwari",
        designation:
          " Department of Physics at the Indian Institute of Technology Roorkee, Greater Noida",
        image: "/nclc-2026/assets/anjani-kumar-tiwari.jpg",
        about: `I am an assistant professor in the Department of Physics at the Indian Institute of Technology Roorkee and also a joint faculty member at the Center for Photonics and Quantum Communication Technology, IIT Roorkee. 

Research Interest: 

Light amplification in disordered amplifying structures, lasing in liquid crystal elastic materials and nanostructured thin film metamaterials.

Quantum optics, Photonic crystals, Topological photonics, metamaterial absorber, plasmonics and mesoscopic phenomena like Anderson localization.

Study of light interaction with microstructures using analysis tools like Transfer Matrix method, Finite Difference Time Domain method, Monte Carlo simulation, and COMSOL, etc. 

Near field studies of passive and active nanostructured materials using Near Field Scanning Optical Microscope.`,
        link: "https://sites.google.com/view/tiwaritifr/home",
      },
      {
        id: 12,
        role: "Organizing Secretary",
        name: "Dr. Satish Kumar Verma",
        designation:
          "Department of Physics & Environmental Sciences, SSES, Sharda University, Greater Noida",
        image: "/nclc-2026/assets/dr-satish-kumar-verma.webp",
        about: `Dr. Satish Kumar Verma is currently working as an Assistant Professor in the Department of Physics & Environmental Sciences, Sharda School of Engineering & Science, Sharda University, Greater Noida, India. His career began at the University of Lucknow, Lucknow (India), where he graduated with a bachelor's degree in 2009 and Masters degree (Renewable Energy) in 2012. He has earned his Masters degree in Physics from Dr. Shakuntala Misra National Rehabilitation University, Lucknow, India in 2017. Afterwards he joined Prof. O. N. Srivastava (Hydrogen Man of India), Banaras Hindu University, Varanasi, India for Doctoral Degree. Dr. Verma earned his Doctoral Degree in the field of ‘Hydrogen Storage and Utilization in December 2022 and went on to join as a Research Scientist (postdoc) in an industry (M/s Hydrogen Horizons (Israel) Ltd.) funded project at Department of Materials Science and Engineering, Technion-Israel Institute of Technology, Haifa, Israel (from January 24, 2023 to July 31, 2023). Afterwards Dr. Verma joined as Project Scientist-I in 'DST-Bio energy and H2 Map' project at Department of Sustainable Energy Engineering, Indian Institute of Technology, Kanpur, India (from August 03, 2023 to June 25, 2024) with Prof. Shobit Omar. During this period, he was involved in the investigation, designing and advanced characterizations of novel materials for hydrogen storage and cooling/refrigeration applications. Dr. Verma joined Sharda University in 2024 as an Assistant Professor.`,
        link: "https://www.sharda.ac.in/faculty/details/dr-satish-kumar-verma/",
      },
      {
        id: 13,
        role: "Organizing Secretary",
        name: "Dr. Shashank Sharma",
        designation:
          "Department of Chemistry and Biochemistry, SSES, Sharda University, Greater Noida",
        image: "/nclc-2026/assets/shashank.webp",
        about:
          "Dr. Shashank Sharma is presently working as an Assistant Professor in the Department of Chemistry & Biochemistry, School of Basic Sciences & Research (SBSR), Sharda University, Greater Noida, Uttar Pradesh. His research interests include especially electrochemistry & environmental chemistry. With more than 12 years of experience in both teaching and research, he has produced more than 35 scientific publications including original research papers, review articles, books, and invited book chapters in the different fields of his research areas published with internationally / nationally reputed publishers. His articles get published in newspapers on various subjects from time to time. He is the editor/reviewer of the International Journal for Research in Applied Sciences and Biotechnology (IJRASB). He has been a resource person for expert talks in several institutions including USERC Dehradun, RBS College, Agra, etc. Dr. Sharma is also an active member of various non-governmental organizations dedicated to social & environmental awareness & conservation. During his career, he has performed a variety of academic and administrative responsibilities along with having experience in organizing national conferences sponsored by the Department of Science & Technology (DST), etc.",
        link: "https://www.sharda.ac.in/faculty/details/shashanksharma/",
      },
    ],
  },
];

const nationalAdvisoryCommittee = [
  { name: "Prof. Ashok M Biradar", designation: "NPL, New Delhi" },
  { name: "Prof. B. T. Thaker", designation: "V.N.S.G. University, Surat" },
  { name: "Prof. K. K. Raina", designation: "VC, RUAS, Bengaluru" },
  { name: "Prof. K. S. Krishnamurthy", designation: "CeNS, Bengaluru" },
  { name: "Prof. Kattera A. Suresh", designation: "RRI, Bengaluru" },
  { name: "Prof. Rajiv Manohar", designation: "VC, DSPMU, Ranchi" },
  { name: "Prof. Ravindra Dhar", designation: "University of Allahabad" },
  {
    name: "Prof. Sandeep Kumar",
    designation: "Sharda University & RRI, Bengaluru",
  },
  { name: "Prof. S. Krishna Prasad", designation: "CeNS, Bengaluru" },
  { name: "Prof. Shri Singh", designation: "BHU, Varanasi" },
  { name: "Prof. Y. Singh", designation: "BHU, Varanasi" },
  { name: "Prof. Y. S. Negi", designation: "IIT Roorkee, Saharanpur" },
];

const scientificAdvisoryCommittee = [
  { name: "Prof. Abhishek Kumar Srivastava", designation: "Hong Kong" },
  { name: "Prof. Dharmendra Pratap Singh", designation: "France" },
  {
    name: "Prof. Hari Krishna Bisoyi",
    designation: "Kent State University, USA",
  },
  { name: "Dr. Pankaj Kumar Tripathi", designation: "Chair" },
  { name: "Prof. (Dr.) Sandeep Kumar", designation: "President, ILCS" },
];

const nationalOrganizingCommittee = [
  { name: "Prof. C.V. Yelamaggad", designation: "CeNS, Bengaluru" },
  { name: "Prof. D.S. Shankar Rao", designation: "CeNS, Bengaluru" },
  { name: "Prof. M.B. Pandey", designation: "VSSD College, Kanpur" },
  { name: "Prof. Maddasani Srinivasulu", designation: "MIT, Karnataka" },
  { name: "Prof. Malay Kumar Das", designation: "NBU, West Bengal" },
  { name: "Prof. M.R. Nanchara Rao", designation: "AU, Visakhapatnam" },
  { name: "Prof. Pankaj Kumar", designation: "Chitkara University" },
  { name: "Prof. Praveen Malik", designation: "NIT Jalandhar" },
  { name: "Prof. Raj Kumar Gupta", designation: "BITS Pilani" },
  { name: "Prof. Ravi K. Shukla", designation: "DIT, Dehradun" },
  { name: "Prof. Santanu Kumar Pal", designation: "IISER, Mohali" },
  { name: "Prof. Surajit Dhara", designation: "University of Hyderabad" },
];

const advisors = [
  {
    name: "Prof. (Dr.) Geetha Ganesan",
    designation:
      "Dean, Sharda School of Computing Science & Engineering, Sharda University, Greater Noida",
  },
  {
    name: "Prof. (Dr.) N.B. Singh",
    designation:
      "Department of Chemistry and Biochemistry, SSES, Sharda University, Greater Noida",
  },
  {
    name: "Prof. (Dr.) Vinay K. Verma",
    designation:
      "Controller of Examination (COE), Sharda University, Greater Noida",
  },
  {
    name: "Prof. (Dr.) Vrince Vimal",
    designation:
      "Professor & Dean Strategy (Development & Growth), EECE, Sharda University, Greater Noida",
  },
];

const coreOrganizingCommittee = [
  { name: "Dr. Amit Choudhary", designation: "Deshbandhu College, DU" },
  { name: "Prof. (Dr.) Anupam Agrawal", designation: "SU" },
  { name: "Dr. Bhupendra Pratap Singh", designation: "NUU, Taiwan" },
  { name: "Dr. Gautam Singh", designation: "Amity University, Noida" },
  { name: "Dr. Kamal Kumar Pandey", designation: "KKC, Lucknow" },
  { name: "Dr. Kaushlendra Agrahari", designation: "KIT, Kanpur" },
  { name: "Dr. Kunwar Vikram", designation: "Graphic Era Deemed to be University, Dehradun" },
  { name: "Prof. (Dr.) Khursheed Alam", designation: "SU" },
  { name: "Prof. (Dr.) Munendra Singh", designation: "SU" },
  { name: "Prof. (Dr.) Pramod Kumar Singh", designation: "SU" },
  { name: "Dr. Sunil Chauhan", designation: "SU" },
  { name: "Dr. Swadesh Kumar Gupta", designation: "DBS College, Kanpur" },
  { name: "Dr. Sweta Srivastava", designation: "SU" },
  { name: "Dr. S.P. Singh", designation: "Amity University, Noida" },
];

const localOrganizingCommittee = [
  { name: "Prof. (Dr.) Ashok Kumar" },
  { name: "Dr. Babita Tripathi" },
  { name: "Dr. Harmohan Singh" },
  { name: "Dr. Jaidev Sharma" },
  { name: "Dr. K.K. Pandey" },
  { name: "Dr. Monika Srivastava" },
  { name: "Dr. Preeti Rani" },
  { name: "Dr. Priya Das" },
  { name: "Dr. S.Shankara Narayanan" },
  { name: "Dr. Sandhya Gupta" },
  { name: "Dr. Sangeeta Rawal" },
  { name: "Dr. Sohan Lal" },
  { name: "Dr. Suman" },
  { name: "Dr. Yogesh Sharma" },
  { name: "Mr. Mohammed Kolo" },
  { name: "Ms. Sunita" },
  { name: "Ms. Vershika Singh" },
  { name: "Ms. Yashika" },
];

/* ── Modal (matches Speakers modal exactly) ─────────────────────────────── */
const MemberModal = ({ member, onClose }) => {
  useEffect(() => {
    if (member) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "";
    }
    return () => {
      document.body.style.overflow = "";
    };
  }, [member]);

  if (!member) return null;

  return (
    <div
      className="fixed inset-0 z-50 flex items-center justify-center bg-black/60 p-4"
      onClick={onClose}
    >
      <div
        className="bg-white rounded-2xl max-w-5xl w-full max-h-[90vh] overflow-y-auto shadow-2xl animate-fade-in"
        onClick={(e) => e.stopPropagation()}
      >
        <div className="relative p-6 md:p-8">
          <button
            onClick={onClose}
            className="absolute top-4 right-4 text-2xl font-bold text-gray-500 hover:text-red-500"
          >
            ×
          </button>

          <div className="flex flex-col md:flex-row gap-8">
            {/* Left: image */}
            <div className="md:w-1/3">
              <img
                src={member.image}
                alt={member.name}
                className="w-full rounded-xl shadow-lg object-cover object-top"
              />
            </div>

            {/* Right: info */}
            <div className="md:w-2/3">
              {/* Role badge */}
              <span className="inline-block px-4 py-1 bg-red-100 text-red-600 rounded-full font-bold text-sm mb-3">
                {member.role}
              </span>

              <h2 className="text-3xl font-bold text-[#1e1b4b] mb-2">
                {member.name}
              </h2>

              <p className="text-indigo-600 font-semibold mb-6">
                {member.designation}
              </p>

              <div className="border-t pt-4">
                <h3 className="text-lg font-semibold mb-3 text-gray-800">
                  About
                </h3>

                <p className="text-gray-700 leading-relaxed whitespace-pre-line mb-5">
                  {member.about}
                </p>
                {member.link && (
                  <a
                    href={member.link}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="text-blue-600 hover:underline"
                  >
                    Visit Profile : {member.link}
                  </a>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

/* ── Page ────────────────────────────────────────────────────────────────── */
const Committee = () => {
  const [selectedMember, setSelectedMember] = useState(null);

  return (
    <>
      <SEO title="Committee" />

      <style>{`
        @keyframes fadeIn {
          from { opacity: 0; transform: scale(0.95) translateY(10px); }
          to   { opacity: 1; transform: scale(1)    translateY(0);    }
        }
        .animate-fade-in { animation: fadeIn 0.25s ease-out forwards; }
      `}</style>

      <div className="min-h-screen bg-[#f8f9fa] py-16 pt-28 px-4 sm:px-6 lg:px-8">
        <div className="max-w-7xl mx-auto">
          <h1 className="text-4xl uppercase font-bold text-center text-[#1e1b4b] mb-16">
            Organizers
          </h1>

          {/* Card sections */}
          {committeeData.map((section, index) => (
            <div key={index} className="mb-20">
              <h2 className="text-2xl font-semibold text-center text-[#1e1b4b] mb-10">
                {section.title}
              </h2>

              <div className="flex flex-wrap justify-center gap-6">
                {section.members.map((member) => (
                  <div
                    key={member.id}
                    onClick={() => setSelectedMember(member)}
                    className="group cursor-pointer w-64 bg-white rounded-2xl overflow-hidden shadow-md border border-gray-100 hover:shadow-xl hover:-translate-y-1 transition-all duration-300"
                  >
                    {/* Image */}
                    <div className="relative h-64 overflow-hidden bg-slate-100">
                      <img
                        src={member.image}
                        alt={member.name}
                        className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                      />
                      <div className="absolute top-3 left-3">
                        <span className="inline-block px-3 py-1 bg-red-600 text-white text-xs font-bold rounded-full shadow">
                          {member.role}
                        </span>
                      </div>
                    </div>

                    {/* Content */}
                    <div className="p-5">
                      <h3 className="text-[#1e1b4b] font-bold text-base leading-snug mb-1">
                        {member.name}
                      </h3>
                      <p className="text-gray-500 text-sm leading-relaxed line-clamp-2">
                        {member.designation}
                      </p>
                      <div className="mt-4 flex items-center text-indigo-600 text-xs font-semibold gap-1 group-hover:gap-2 transition-all">
                        <span>View Profile</span>
                        <span>→</span>
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          ))}

          {/* List sections */}
          {[
            {
              title: "National Advisory Committee",
              data: nationalAdvisoryCommittee,
            },
            {
              title: "Scientific Advisory Committee",
              data: scientificAdvisoryCommittee,
            },
            {
              title: "National Organizing Committee",
              data: nationalOrganizingCommittee,
            },
            { title: "Advisor(s)", data: advisors },
            {
              title: "Core Organizing Committee",
              data: coreOrganizingCommittee,
            },
            {
              title: "Local Organizing Committee",
              data: localOrganizingCommittee,
            },
          ].map((section, idx) => (
            <div
              key={idx}
              className="mb-20 bg-white py-12 px-6 rounded-2xl shadow-sm border border-gray-100 max-w-4xl mx-auto"
            >
              <h2 className="text-2xl font-semibold text-center text-[#1e1b4b] mb-8">
                {section.title}
              </h2>

              <ul className="space-y-2 text-left max-w-2xl mx-auto">
                {section.data.map((item, index) => (
                  <li
                    key={index}
                    className="flex items-start gap-3 text-[15px]"
                  >
                    <span className="mt-1.5 w-2 h-2 rounded-full bg-indigo-400 flex-shrink-0"></span>
                    <span className="text-gray-700">
                      <span className="font-semibold text-gray-900">
                        {item.name}
                      </span>
                      {item.designation && (
                        <span className="text-gray-500">
                          {" "}
                          ({item.designation})
                        </span>
                      )}
                    </span>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>
      </div>

      {/* Modal */}
      <MemberModal
        member={selectedMember}
        onClose={() => setSelectedMember(null)}
      />
    </>
  );
};

export default Committee;

